/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { styled } from 'styled-components/native'

import { getBorderHoverStyle, getRadioColors } from 'ui/designSystem/RadioButton/helpers'
import { RadioStateObject } from 'ui/designSystem/RadioButton/types'

type RadioCircleProps = {
  variant: 'default' | 'detailed'
  radioState: RadioStateObject
  isHover?: boolean
}

export const RadioOuterCircle = styled.View<RadioCircleProps>(
  ({ theme, variant, isHover, radioState }) => ({
    width: theme.radioButton.size,
    height: theme.radioButton.size,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.borderRadius.radioButton,
    borderWidth: theme.radioButton.border.size,
    ...getRadioColors(radioState, theme, {
      componentPart: 'circle',
      variant,
    }),
    ...getBorderHoverStyle({ radioState, theme, isHover }),
  })
)

export const RadioInnerDot = styled.View<RadioCircleProps>(
  ({ theme, variant, isHover, radioState }) => ({
    width: theme.radioButton.innerDotSize,
    height: theme.radioButton.innerDotSize,
    borderRadius: theme.designSystem.size.spacing.m / 2,
    justifyContent: 'center',
    alignItems: 'center',
    ...getRadioColors(radioState, theme, {
      componentPart: 'round',
      variant,
    }),
    ...getBorderHoverStyle({ radioState, theme, isHover }),
  })
)
